import { defaultLocale } from "react-day-picker";
import { useTranslations } from "../../../../providers/useTranslations";
export const useCustomLocale = () => {
    const { __ } = useTranslations();
    return {
        ...defaultLocale,
        localize: {
            ...defaultLocale.localize,
            day: (day) => {
                const dayName = __("daypicker.day." + (day + 1));
                return dayName;
            },
        },
    };
};
//# sourceMappingURL=useCustomLocale.js.map